import * as BoardConstants from "@/game/constants/boardConstants.ts";
import { Graphics } from "@pixi/react";
import React from "react";

interface GameBoardDebugOverlaysProps {
  bar1Area: [number, number, number, number];
  bar2Area: [number, number, number, number];
  bearOff1Area: [number, number, number, number];
  bearOff2Area: [number, number, number, number];
  diceArea: [number, number, number, number];
  getPointArea: (index: number, isTop: boolean) => [number, number, number, number];
  isFlipped: boolean;
  stageWidth: number;
  stageHeight: number;
}

const DebugRect: React.FC<{ color: number; area: [number, number, number, number] }> = ({
  color,
  area
}) => (
  <Graphics
    draw={(g) => {
      g.clear();
      g.lineStyle(2, color, 1);
      g.drawRect(area[0], area[1], area[2], area[3]);
    }}
  />
);

export const GameBoardDebugOverlays: React.FC<GameBoardDebugOverlaysProps> = ({
  bar1Area,
  bar2Area,
  bearOff1Area,
  bearOff2Area,
  diceArea,
  getPointArea,
  isFlipped,
  stageWidth,
  stageHeight
}) => {
  const renderPoint = (index: number, isTop: boolean) => {
    const area = getPointArea(index, isTop);
    return (
      <React.Fragment key={`${isTop ? "t" : "b"}-${index}`}>
        <DebugRect color={0xffff00} area={area} />
      </React.Fragment>
    );
  };

  return BoardConstants.BOARD_DEBUG_RENDERING ? (
    <>
      <DebugRect color={0x00ff00} area={bar1Area} />
      <DebugRect color={0x0000ff} area={bar2Area} />
      <DebugRect color={0x00ff00} area={bearOff1Area} />
      <DebugRect color={0x0000ff} area={bearOff2Area} />
      <DebugRect color={0xff0000} area={diceArea} />
      {[11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0].map((i) => renderPoint(i, true))}
      {[11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0].map((i) => renderPoint(i, false))}
      <DebugRect color={isFlipped ? 0xff0000 : 0xff00ff} area={[0, 0, stageWidth, stageHeight]} />
    </>
  ) : null;
};
